export const addressEditModes = {
  ADD: 'create',
  EDIT: 'update',
  DELETE: 'delete',
};

export const trustScienceClientId = 'trustscience';
export const clientIdAttribute = 'custom:clientId';
export const signOutRedirectUrl = 'https://trustscience.com';
